import { GET_SUBSCRIPTION_BANNER } from "../actions/types";
const initState = {
    show_banner: false,
    banner: "",
};
export default function showBannerReducer(state = initState, action) {
    switch (action.type) {
        case GET_SUBSCRIPTION_BANNER: {
            return {
                ...state,
                banner: action.payload.banner,
                show_banner: action.payload.show_banner,
            };
        }
        default:
            return state;
    }
}
